import { HiCog6Tooth } from "react-icons/hi2"
import { QueryBoundary } from "~/components/query-boundary"
import { SettingsItemSkeleton } from "~/components/settings-item-skeleton"
import { SpinnerFallback } from "~/components/spinner-fallback"
import { PlansTrigger, PlansTriggerLabel } from "~/features/plans/components/plans-drawer"
import { SettingsItem } from "~/components/settings-item"
import { MyProfile } from "./my-profile"
import { UnreadNotifications } from "./unread-notifications"

export function ProfileTab() {
  return (
    <>
      <QueryBoundary loadingFallback={<SpinnerFallback />}>
        <MyProfile />
      </QueryBoundary>
      <div className="px-m bg-card">
        <QueryBoundary loadingFallback={<SettingsItemSkeleton className="border-t" />}>
          <PlansTrigger>
            <PlansTriggerLabel />
          </PlansTrigger>
        </QueryBoundary>
        <QueryBoundary loadingFallback={<SettingsItemSkeleton className="border-t" />}>
          <UnreadNotifications />
        </QueryBoundary>
        <SettingsItem text="Настройки" to="/profile/settings" icon={<HiCog6Tooth />} className="border-t" />
      </div>
    </>
  )
}
